/* @flow */

import React from 'react';

type Props = {
  children?: string,
  className?: string,
  source?: string
};

const nonBreakingSpacePattern = /&nbsp;/g;

function normaliseText(value) {
  return String(value || '').replace(nonBreakingSpacePattern, '\u00a0');
}

function renderInlineText(value) {
  const boldPattern = /\*\*(.+?)\*\*/g;
  const parts = [];
  let lastIndex = 0;
  let match = boldPattern.exec(value);

  while (match) {
    if (match.index > lastIndex) {
      parts.push(value.slice(lastIndex, match.index));
    }

    parts.push(<strong key={`strong-${match.index}`}>{match[1]}</strong>);
    lastIndex = match.index + match[0].length;
    match = boldPattern.exec(value);
  }

  if (lastIndex < value.length) {
    parts.push(value.slice(lastIndex));
  }

  return parts;
}

function SimpleMarkdownText({ children, className, source }: Props) {
  const text = normaliseText(source || children);
  const lines = text.split(/\n{2,}/);

  return (
    <div className={className}>
      {lines.map((line, index) => (
        <p key={index}>{renderInlineText(line)}</p> // eslint-disable-line react/no-array-index-key
      ))}
    </div>
  );
}

SimpleMarkdownText.defaultProps = {
  children: undefined,
  className: undefined,
  source: undefined
};

export default SimpleMarkdownText;
